<template>
  <div id="app">
    <img :src="topImg" class="top fadeIn animated" />

    <transition
      mode="out-in"
      enter-active-class="fadeIn animated faster"
      leave-active-class="fadeOut animated faster"
    >
      <router-view></router-view>
    </transition>

    <tech></tech>
  </div>
</template>

<script>
import tech from "@zj/tech";

export default {
  name: "app",
  components: { tech },
  data() {
    return {
      topImg: window.activity.topImg,
      isFans: window.activity.isfans
    };
  },
  created() {
    this.isFans = this.$activity.isFans;
    this.topImg = this.$activity.topImg;
    if (!window.activity.start) this.swal("活动未开始", "", "warning");
    else if (window.activity.end) this.swal("活动已结束", "", "warning");
    this.$router.push("/");
  }
};
</script>

<style lang="scss">
$rootUrl: "./assets/images/";

@import "./assets/scss/sweetAlert.reset.scss";

#app {
  min-height: 100%;
  position: relative;
  padding-bottom: 1.5rem;
}

body {
  background-color: #c91b20;
}

.weui-toast {
  background-color: rgba(76, 76, 76, 0.9);
}
// .weui-mask,
// .weui-mask_transparent {
//   background-color: var(--weui-FG-2);
// }
</style>
